export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    title: that.$l('order_package_packingType') || '装箱方式',
    field: 'v_packingType',
    width: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('order_packing_outBillType') || '出单类型',
    field: 'v_outBillType',
    width: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('order_packing_dispatchPort') || '发运港口',
  //   field: 'v_dispatchPort',
  //   minWidth: 120,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  //   sortable: true,
  //   sortType: 'string'
  // },
  // {
  //   title: that.$l('order_packing_destinationPort') || '目的港口',
  //   field: 'v_destinationPort',
  //   minWidth: 120,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  //   sortable: true,
  //   sortType: 'string'
  // },
  {
    title: that.$l('order_package_materialNo') || '物料编号',
    field: 'materialNo',
    width: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('order_package_materialName') || '物料名称',
    field: 'materialName',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
    slots: {
      default: 'showName',
    },
  },
  {
    title: that.$l('order_package_materialSpec') || '箱规格',
    field: 'materialSpec',
    minWidth: 160,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('order_package_boxUnitPrice') || '箱单价',
    field: 'boxUnitPrice',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('order_package_orderPackingDesc') || '装箱方案描述',
    field: 'orderPackingDesc',
    minWidth: 320,
    align: 'center',
    showHeaderOverflow: true,
  },
  // {
  //   title: that.$l('order_package_boxVolume')||"箱体积",
  //   field: "boxVolume",
  //   width: 120,
  //   headerAlign: "center",
  //   align: "center",
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('order_package_boxWeight')||"箱重量",
  //   field: "boxWeight",
  //   width: 100,
  //   headerAlign: "center",
  //   align: "center",
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('order_packing_boxGoodsWeight')||"净重(g)",
  //   field: "boxGoodsWeight",
  //   width: 100,
  //   headerAlign: "center",
  //   align: "center",
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('order_packing_totGrossWeight')||"毛重(g)",
  //   field: "totGrossWeight",
  //   width: 100,
  //   headerAlign: "center",
  //   align: "center",
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_time') || '修改时间',
    field: 'modifyTime',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
